import { HardwareSupplierFilterKeyType, SUPPLIER_INTEGRATION_TYPES } from 'opensolar-common'
import { useGetSupplierConfig } from './useGetSupplierConfig'

/**
 * Determines whether the pricing shown is indicative (estimated) based on the selected supplier's integration type.
 *
 * @param supplierFilterKey - The supplier filter key of the selected distributor.
 * @returns true if the supplier has an integration type of 'indicative_pricing'.
 */
const useIsIndicativePricing = (supplierFilterKey: HardwareSupplierFilterKeyType | undefined): boolean => {
  const { getSupplierConfig } = useGetSupplierConfig()

  if (!supplierFilterKey || supplierFilterKey === 'component') return false
  return getSupplierConfig(supplierFilterKey)?.integrationType === SUPPLIER_INTEGRATION_TYPES.INDICATIVE_PRICING
}

export default useIsIndicativePricing
